import { InjectionToken } from '@angular/core';

export interface PusherConfig {
  key: string;
  cluster: string;
}

export const PUSHER_CONFIG = new InjectionToken<PusherConfig>('PUSHER_CONFIG');
